import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionDescription } from "./description";
import { QuestionOptionKeyVisual } from "./key-visual";
import { QuestionOptionName } from "./name";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: StandardOptionCategoriesAndManagerStore["base"];

	hotelID: string;
	optionID: string;
};

export const QuestionOptionBase = ({ base, hotelID, optionID }: Props) => {
	const ownerID = hotelID;
	const resourceID = optionID;

	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionOptionName />
			<QuestionOptionKeyVisual ownerID={ownerID} resourceID={resourceID} />
			<QuestionOptionDescription />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionBase.displayName = "QuestionOptionBase";
